import { lazy } from "react";
import { Route } from "react-router-dom";
import { ProtectedRoute } from "@/components/auth/ProtectedRoute";

const GroupsPage = lazy(() => import("@/pages/groups/GroupsPage"));
const GroupCreatePage = lazy(() => import("@/pages/groups/GroupCreatePage"));
const GroupEditPage = lazy(() => import("@/pages/groups/GroupEditPage"));

export function GroupRoutes() {
  return (
    <>
      <Route path="groups" element={<ProtectedRoute><GroupsPage /></ProtectedRoute>} />
      <Route path="groups/new" element={<ProtectedRoute><GroupCreatePage /></ProtectedRoute>} />
      <Route path="groups/:id" element={<ProtectedRoute><GroupEditPage /></ProtectedRoute>} />
    </>
  );
}
